<template>
  <v-container
    fluid
    class="fill-height flex-fill"
  >
    <v-row
      v-if="this.$appMng.isLoadingPage"
      justify="center"
      align="center"
      class="fill-height"
    >
      <loading-screen/>
    </v-row>
    <v-row
      v-else
      justify="center"
      align="start"
      class="fill-height ma-0"
    >
      <v-stepper
        v-model="step"
        @change="onStepChange"
        alt-labels
      >
        <v-stepper-header
        id="processing-stepper-header"
        >
          <v-stepper-step
            :complete="stepsDone[processingSteps.BASIC]"
            complete-icon="mdi-check"
            edit-icon="mdi-pencil"
            editable
            :step="processingSteps.BASIC"
          >
            <span class="text-center">Tipo do processamento</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :complete="stepsDone[processingSteps.ADVANCED]"
            complete-icon="mdi-check"
            :editable="hasProcessingAdvanced && stepsDone[processingSteps.ADVANCED]"
            edit-icon="mdi-pencil"
            :step="processingSteps.ADVANCED"
          >
            <span class="text-center">Configurações do processamento</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step
            :complete="stepsDone[processingSteps.UPLOAD]"
            complete-icon="mdi-check"
            :editable="stepsDone[processingSteps.UPLOAD]"
            edit-icon="mdi-pencil"
            :step="processingSteps.UPLOAD"
          >
            <span class="text-center">Upload de imagens</span>
          </v-stepper-step>
          <v-divider/>
          <v-stepper-step :complete="stepsDone[processingSteps.SUMMARY]" :step="processingSteps.SUMMARY">
            <span class="text-center">Resumo do processamento</span>
          </v-stepper-step>
        </v-stepper-header>
        <v-row
          align="center"
          justify="center"
          class="fill-height ma-0"
        >
          <v-col
            cols="12"
            md="10"
            lg="10"
            xl="8"
            class="justify-center"
          >
            <v-stepper-items>
              <v-stepper-content :step="processingSteps.BASIC">
                <processing-basic id="processing-stepper-basic"/>
              </v-stepper-content>
              <v-stepper-content :step="processingSteps.ADVANCED">
                <processing-advanced id="processing-stepper-advanced"/>
              </v-stepper-content>
              <v-stepper-content :step="processingSteps.UPLOAD">
                <processing-upload id="processing-stepper-upload"/>
              </v-stepper-content>
              <v-stepper-content :step="processingSteps.SUMMARY">
                <processing-summary id="processing-stepper-summary"/>
              </v-stepper-content>
            </v-stepper-items>
          </v-col>
        </v-row>
      </v-stepper>
    </v-row>
  </v-container>
</template>

<script>
  import {mapActions, mapGetters} from "vuex"
  import {
    GET_ID_PROCESSING,
    GET_PROCESSING_DATA,
    GET_PROCESSING_DB,
    GET_PROCESSING_IS_CREATED,
    GET_PROCESSING_IS_CREATING,
    GET_PROCESSING_TO_CREATE_DATA,
  } from "../../../store/modules/processing"
  import {PROCESSING_STATUS, PROCESSING_STEPS, PROCESSING_TYPES} from "../../../helpers/processings/constants"
  import {LIST_PROJECT} from "../../../store/modules/project"
  import {indexOf} from "lodash/array"
  import {isEmpty, isEqual} from "lodash/lang"
  import {forEach} from "lodash/collection"
  import {ProcessingStepperEventBus} from "../../../helpers/processings/events"
  import ProcessingSummary from "../../../components/Processings/Configuration/ProcessingSummary"
  import ProcessingUpload from "../../../components/Processings/Configuration/ProcessingUpload"
  import ProcessingAdvanced from "../../../components/Processings/Configuration/ProcessingAdvanced"
  import ProcessingBasic from "../../../components/Processings/Configuration/ProcessingBasic"
  import LoadingScreen from "../../../components/Helpers/LoadingScreen"
  import {DIALOG_TYPES, DialogOptions} from "../../../helpers/dialogs"

  const ProcessingLastStep = Symbol.for("ProcessingLastStep")
  const ProcessingNextStep = Symbol.for("ProcessingNextStep")
  const ProcessingSetStep = Symbol.for("ProcessingSetStep")

  export default {
    name: "ProcessingStepper",
    components: {
      LoadingScreen,
      ProcessingSummary,
      ProcessingUpload,
      ProcessingAdvanced,
      ProcessingBasic,
    },
    data: () => ({
      step: null,
      stepsDone: {},
    }),
    provide() {
      return {
        [ProcessingLastStep]: this.lastStep,
        [ProcessingNextStep]: this.nextStep,
        [ProcessingSetStep]: this.setStep,
      }
    },
    methods: {
      onMounted() {
        this._listProject()
        if (this._idProcessing) {
          this._getProcessingDB(this._idProcessing)
            .then(() => {
              this.$appMng.setTitle(this._processingData["nm_processing"])
              this.handleStepByStatus()
            })
        } else if (this._processingIsCreating) {
          this.$appMng.setTitle(this._processingToCreateData["nm_processing"])
          this.handleStepByStatus()
        } else {
          this.$appMng.setTitle("Novo processamento")
          this.$appMng.setIsLoadingPage(false)
        }
      },
      handleStepByStatus() {
        this.$appMng.setIsLoadingPage(false)
        setTimeout(() => {
          if (this._processingIsCreated) {
            switch (this._processingData["ab_processing_status"]) {
              case PROCESSING_STATUS.CREATED:
                this.setStep(PROCESSING_STEPS.ADVANCED)
                break
              case PROCESSING_STATUS.READY_TO_UPLOAD:
                this.setStep(PROCESSING_STEPS.UPLOAD)
                break
              case PROCESSING_STATUS.READY_TO_PAY:
                this.setStep(PROCESSING_STEPS.SUMMARY)
                break
              default:
                this.setStep(PROCESSING_STEPS.BASIC)
                break
            }
          } else if (this._processingIsCreating) {
            this.setStep(PROCESSING_STEPS.ADVANCED)
          } else {
            this.setStep(PROCESSING_STEPS.BASIC)
          }
        }, 300)
      },
      lastStep() {
        const stepsArray = Object.values(PROCESSING_STEPS)
        const currIdx = indexOf(stepsArray, this.step)
        let lastIdx = (currIdx - 1 > -1) ? currIdx - 1 : 0
        this.step = stepsArray[lastIdx]
        ProcessingStepperEventBus.$emit("step-change", stepsArray[lastIdx])
      },
      nextStep() {
        const stepsArray = Object.values(PROCESSING_STEPS)
        const currIdx = indexOf(stepsArray, this.step)
        let nextIdx = (currIdx + 1 < stepsArray.length) ? currIdx + 1 : stepsArray.length - 1
        this.$set(this.stepsDone, stepsArray[currIdx], true)
        this.step = stepsArray[nextIdx]
        ProcessingStepperEventBus.$emit("step-change", stepsArray[nextIdx])
      },
      setStep(stepName) {
        const stepsArray = Object.values(PROCESSING_STEPS)
        const stepIndex = indexOf(stepsArray, stepName)
        if (stepIndex === -1) return
        this.step = stepName
        for (let i of [...Array(stepIndex).keys()]) {
          this.$set(this.stepsDone, stepsArray[i], true)
        }
        ProcessingStepperEventBus.$emit("step-change", stepName)
      },
      onStepChange(step) {
        ProcessingStepperEventBus.$emit("step-change", step)
      },
      ...mapActions({
        _listProject: LIST_PROJECT,
        _getProcessingDB: GET_PROCESSING_DB,
      }),
    },
    computed: {
      hasProcessingAdvanced() {
        if (isEmpty(this._processingData)) return false
        const processingType = this._processingData["ab_processing_type"]
        return processingType && isEqual(processingType, PROCESSING_TYPES.FULL_PROCESSING)
      },
      processingSteps() {
        return PROCESSING_STEPS
      },
      ...mapGetters({
        _idProcessing: GET_ID_PROCESSING,
        _processingData: GET_PROCESSING_DATA,
        _processingToCreateData: GET_PROCESSING_TO_CREATE_DATA,
        _processingIsCreating: GET_PROCESSING_IS_CREATING,
        _processingIsCreated: GET_PROCESSING_IS_CREATED,
      }),
    },
    mounted() {
      let stepsBool = Object.values(PROCESSING_STEPS).map(value => ({key: value, value: false}))
      forEach(stepsBool, (item) => {
        const {key, value} = item
        this.stepsDone[key] = value
      })

      this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())
        .then(() => {

          let errTitle = null
          let errContent = null
          let showErr = false
          let dialogType = null
          if (this.$subsMng.hasError) {
            showErr = true
            dialogType = DIALOG_TYPES.ALERT
            errTitle = "Erro ao carregar seu plano"
            errContent = "Ocorreu um erro ao carregar seu plano, por favor tente novamente mais tarde"
          } else if (this.$subsMng.isSubscriptionEmpty || !this.$subsMng.subscription["bl_activated"]) {
            showErr = true
            dialogType = DIALOG_TYPES.SUBSCRIPTION_EXPIRED
            errTitle = "Plano inativo"
            errContent = "Para processar suas imagens, assine agora."
          }

          if (showErr) {
            this.$dialog(new DialogOptions({
              title: errTitle,
              content: errContent,
              type: dialogType
            }))
            this.$router.push("/app/processing-list")
            return
          }

          this.onMounted()
        })
    },
  }
</script>

<style scoped lang="scss">

  .v-stepper {
    width: 100%;
  }

  .v-stepper-items {
    background: transparent !important;
  }

  .v-btn {
    font-size: 22px;
  }

</style>
